import React, { useState } from "react";
import "./AccessField.css";

export default function AccessField({ field_value, onAccessClick }) {
  const [showLoader, setShowLoader] = useState(false);
  const [unlockedValue, setUnlockedValue] = useState(null);
  const NO_EMAIL = "email_not_unlocked@domain.com";

  const handleShowField = async (e) => {
    try {
      setShowLoader(true);
      const result = await onAccessClick(e); // assume it returns the real email
      if (result) {
        setUnlockedValue(result); // store updated email
      }
    } catch (err) {
      console.error("Access error", err);
    } finally {
      setShowLoader(false);
    }
  };

  const displayValue = unlockedValue || field_value;

  if (!displayValue) return null;

  return (
    <>
      {displayValue && displayValue !== NO_EMAIL && displayValue !=null ? (
        <div className="access_mob_subbock mr-0">
          <span className="access_mob_text_show">{displayValue}</span>
        </div>
      ) : (
        <div
          className="access_mob_subbock mr-0 cursorP"
          onClick={handleShowField}
        >
          {showLoader ? <i className="fa fa-spinner fa-spin mr-2"></i> : null}
          <img
            src="/img/access_mail_new.png"
            alt="icon"
            className="access_mob_icon"
          />
          <span className="access_mob_text">Access Email</span>
        </div>
      )}
    </>
  );
}
